// extracted by mini-css-extract-plugin
export default {"wrapper":"slider_wrapper__vKLcg","labels":"slider_labels__WT2vv","slider":"slider_slider__LtHb6"};